<template>
  <div id="app">
    <div class="container">
      <div class="header">
        <a href="https://cs.mines.edu/" target="_blank">
          <img class="pure-img" src="./assets/CS_logo_small.jpg" alt="CS@Mines Logo"/>
        </a>
        <table>
          <tr>
            <td class="heading">CSCI 403: Database Management</td>
            <td class="heading-right">Spring 2020</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="$mq == 'sm' || $mq == 'md'" class="nav-mobile">
      <div class="hamburger">
        <a v-on:click="menuActive = !menuActive">
          <img src="./assets/toggle.png"/>
        </a>
      </div>
      <div v-if="menuActive" class="pure-menu">
        <ul class="pure-menu-list">
          <li class="pure-menu-item"><router-link to="/" class="pure-menu-link">&middot; CSCI 403 Home</router-link></li>
          <li class="pure-menu-item"><router-link to="/policies" class="pure-menu-link"> &middot; Policies</router-link></li>
          <li class="pure-menu-item"><router-link to="/schedule" class="pure-menu-link"> &middot; Schedule</router-link></li>
          <li class="pure-menu-item"><router-link to="/projects" class="pure-menu-link"> &middot; Projects</router-link></li>
          <li class="pure-menu-item"><router-link to="/help" class="pure-menu-link"> &middot; Help!</router-link></li>
        </ul>
      </div>
    </div>
    <div v-else class="nav">
      <router-link to="/">CSCI 403 Home</router-link>
      &middot;
      <router-link to="/policies">Policies</router-link>
      &middot;
      <router-link to="/schedule">Schedule</router-link>
      &middot;
      <router-link to="/projects">Projects</router-link>
      &middot;
      <router-link to="/help">Help!</router-link>
    </div>
    <div class="container" id="main-body">
      <router-view/>
    </div>
    <div class="footer">
      <a href="https://cs.mines.edu/" target="_blank">
        <img class="pure-img logo" src="./assets/CS_mines_logo.png" alt="CS@Mines Logo"/>
      </a>
      <p>Copyright &copy; 2020 Christopher Painter-Wakefield</p>
    </div>
  </div>
</template>

<style>
body {
    background: #FFFFFF;
    font-family: "Trebuchet MS", Verdana, Arial, sans-serif;
    line-height: 1.5em; 
    color: #21314D;
}

/*
#main-body {
    background: rgba(255, 255, 255, 0.8);
    background-image: url("./assets/priorsemester.png");
    background-blend-mode: lighten;
}
*/

p {
  padding-bottom: 2px;
}

a {
  color: #D2492A;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.ta-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
}

.ta-entry {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 25px;
  padding-bottom: 25px;
}

.ta-item {
  margin: auto;
  width: 145px;
}

.portrait {
  width: 120px;
}
.container {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 5px;
}

.header a img {
  padding-top: 5px;
  padding-bottom: 5px;
}

.heading, .heading-right {
  font-size: 2em;
  line-height: 120%;
}

.heading-right {
  text-align: right;
}

.header table {
	width: 100%;
}

.header table td {
  border: 0px;
  padding: 0px;
}

.nav { 
  background: white; 
  border-top: 2px solid #D2492A;
  border-bottom: 2px solid #D2492A; 
  padding: 5px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
  color: #D2492A
}

.nav a {
	color: #21314D;
}

.nav-mobile {
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -ms-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
}

.nav-mobile {
  z-index: 1000; /* so the menu or its navicon stays above all content */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-mobile {
  background: white;
  border-top: 2px solid #D2492A;
  border-bottom: 2px solid #D2492A; 
  padding: 5px;
  margin-top: 5px;
  font-size: 18px;
  color: #D2492A;
}

.nav-mobile .pure-menu .pure-menu-list .pure-menu-item :hover {
  background-color: #92A2BD;
  text-decoration: none;
}
.nav-mobile .pure-menu .pure-menu-list .pure-menu-item a {
  color: #21314D;
}

table th, table td {
  border: 1px solid #B2B4B3;
  border-collapse: collapse;
  padding: 5px;
  text-align: left;
  vertical-align: top;
}

table th {
  border-bottom: 3px double;
}

.lined-table th, .lined-table td {
  border-top: 0px;
  border-left: 0px;
  border-bottom: 1px solid #B2B4B3;
  border-right: 1px solid #B2B4B3;
  padding: 5px;
  text-align: left;
  vertical-align: top;
}

.unlined-table th, .unlined-table td {
  border: 0px;
  padding-top: 5px;
  padding-right: 15px;
  text-align: left;
  vertical-align: top;
}

code {
  font-family: Consolas, "Ubuntu Mono", monospace;
  background-color: #E4E7EB;
  border-radius: 4px;
  padding: 5px;
}

pre {
  font-family: Consolas, "Ubuntu Mono", monospace;
  background-color: #E4E7EB;
  border-radius: 10px;
  padding: 10px;
  display: block;
}

pre code {
  padding: 0px;
}

.calendar {
  max-width: 900px;
}

.calendar-table {
  border-collapse: collapse;
  border: 1px solid #21314D;
  table-layout: fixed;
  width: 100%;
}

.calendar-table tr th, .calendar-table tr td {
  border: 1px solid #21314D;
  padding: 5px;
  vertical-align: top;
  text-align: left;
  font-size: 110%;
}

.calendar-table tr th {
  font-size: 125%;
  font-weight: bold;
  border-bottom: 3px double #21314D;
}

.month-header {
  font-size: 125%;
  font-weight: bold;
}

.calendar-mobile .calendar-table tr th.month-header {
  border-top: 3px double #21314D;
}

.calendar-mobile .calendar-table tr:first-child th.month-header {
  border-top: 1px solid #21314D;
}

.calendar-mobile .calendar-table tr td {
  border-bottom: 1px solid #E4E7EB;
}
.calendar-table tr td.end-of-week {
  border-bottom: 1px solid #21314D;
}

.date-header {
  font-weight: 700;
}

.day-of-week-header {
  color: #92A2BD;
  font-size: 90%;
  font-weight: 700;
}

.calendar-event p {
  margin-top: 6px;
  margin-bottom: 4px;
}

.calendar-blockout {
  background-color: #D2492A;
}

.footer {
    background: #21314D; 
    padding-top: 30px; 
    padding-bottom: 20px;
    color: #92A2BD; 
    width: 100%;
    margin: 0px;
    text-align: center;
}

.footer img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
}

.logo {
  background-color: white;
  padding: 10px;
  border-radius: 4px;
}
</style>

<script>
export default {
  name: 'App',
  data() {
    return {
      menuActive: false
    }
  },
  watch: {
    '$route' () {
      this.menuActive = false;
    }
  }
}
</script>
